import styled from 'styled-components/native'
import Button from 'APP/Converse/Button'
import Typography from 'APP/Converse/Typography'
import { isMobile } from 'APP/Helpers/checkPlatform'

export const Container = styled.View`
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.elementsBg};
  padding: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  border-style: solid;
  border-bottom-width: 1px;
  border-left-width: ${isMobile() ? '0px' : '1px'};
  border-right-width: ${isMobile() ? '0px' : '1px'};
  border-color: ${({ theme }) => theme.colors.elementsBorder};
`

export const Distance = styled(Typography)`
  text-align: right;
`

export const Title = styled(Typography).attrs({
  variant: 'h3',
  numberOfLines: 2,
})`
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin / 4}px;
  flex: 1;
`

export const Meta = styled.View`
  flex-direction: row;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin / 4}px;
`

export const MetaItem = styled.View`
  flex-direction: row;
  align-items: center;
  display: flex;
  justify-content: center;
`

export const Actions = styled.View`
  flex-direction: row;
  margin-top: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export const StyledAction = styled(Button).attrs({
  variant: 'secondary',
  small: true,
  iconColor: 'accent',
})`
  margin-right: ${({ theme }) => theme.metrics.baseMargin - 4}px;
  width: 160px;
`

export const TextWithSpacing = styled(Typography)<{ ml?: number; mr?: number }>`
  margin-left: ${({ ml }) => ml || 0}px;
  margin-right: ${({ mr }) => mr || 0}px;
`
export const TitleContainer = styled.View`
  flex-direction: row;
  align-items: center;
`
